import React, { useContext, useState, useEffect } from 'react';
import { DataContext } from '../contexts/DataContext';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import logo from '../wisdom.png';
// Import card components
import ShipmentTransBarChart from './ShipmentTransBarChart';
import ShipmentCountCard from './ShipmentCountCard';
import ShipmentStatusCard from './ShipmentStatusCard';
import FreightUnderManagementCard from './FreightUnderManagementCard';
import ShipmentTimingCard from './ShipmentTimingCard';
import ShipmentModeBarChart from './ShipmentModeBarChart';
import ShipmentDefaultUqPieChart from './ShipmentDefaultUqPieChart';
import ShipmentsPerWeekChart from './ShipmentsPerWeekChart';
import ShipmentTimeSeriesChart from './ShipmentsTimeSeriesChart';
import ShipmentsByCarrierPieChart from './ShipmentsByCarrierPieChart';
import ShipmentsByConsignorPieChart from './ShipmentsByConsignor';
import ShipmentArrivalCalendar from './ShipmentArrivalCalendar';
import StatusModulationCard from './StatusModulationCard';
import TrafficReferenceTimeSeriesCard from './TrafficReferenceTimeSeriesCard ';
import StatusPedimentoCard from './StatusPedimentoCard';
import InventoryStatusCard from './InventoryStatusCard';
import InventoryStatusPercentageCard from './InventoryStatusPercentageCard';

function FFDashboard() {
    const { shipments, fetchDataBasedOnFilter } = useContext(DataContext);
    const [selectedCarrierNames, setSelectedCarrierNames] = useState([]);
    const [selectedJobStatuses, setSelectedJobStatuses] = useState([]);
    const [carrierOptions, setCarrierOptions] = useState([]);
    const [jobStatusOptions, setJobStatusOptions] = useState([]);

    useEffect(() => {
        if (shipments) {
            const uniqueCarriers = Array.from(new Set(shipments.map(s => s.carrierName)))
                .map(carrierName => ({ value: carrierName, label: carrierName }));
            setCarrierOptions(uniqueCarriers);

            // Assuming jobStatus is a property of each shipment
            const uniqueJobStatuses = Array.from(new Set(shipments.map(s => s.jobStatus)))
                .map(jobStatus => ({ value: jobStatus, label: jobStatus }));
            setJobStatusOptions(uniqueJobStatuses);
        }
    }, [shipments]);

    const handleCarrierFilterChange = (selectedOptions) => {
        const newSelectedCarrierNames = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setSelectedCarrierNames(newSelectedCarrierNames);
        fetchDataBasedOnFilter({ carrierNames: newSelectedCarrierNames, jobStatuses: selectedJobStatuses });
    };

    const handleJobStatusFilterChange = (selectedOptions) => {
        const newSelectedJobStatuses = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setSelectedJobStatuses(newSelectedJobStatuses);
        fetchDataBasedOnFilter({ carrierNames: selectedCarrierNames, jobStatuses: newSelectedJobStatuses });
    };

    // Update the Select component to use carrierOptions for options and to calculate its value
    return (
        <div className="flex flex-col h-screen bg-gray-100">
            <nav className="w-full flex justify-between items-center px-6 py-4 bg-white shadow">
                <div className="flex items-center">
                    <img src={logo} alt="Company logo" className="h-12 mr-2" />
                </div>
                <div className="text-xl font-semibold text-gray-700">
                    Traffic Operations Control Tower
                </div>
            </nav>
            <div className="flex-grow overflow-auto">
                <header className="px-6 py-8">

                    <h1 className="text-3xl font-bold text-gray-700 mb-4">Operation Overview</h1>
                    <div className="flex flex-wrap -mx-2 mb-4">
                        <div className="px-2 w-full sm:w-1/2">
                            <Select
                                options={carrierOptions}
                                isMulti
                                onChange={handleCarrierFilterChange}
                                value={carrierOptions.filter(option => selectedCarrierNames.includes(option.value))}
                                placeholder="Filter by Carrier Name"
                            />
                        </div>
                        <div className="px-2 w-full sm:w-1/2">
                            <Select
                                options={jobStatusOptions}
                                isMulti
                                onChange={handleJobStatusFilterChange}
                                value={jobStatusOptions.filter(option => selectedJobStatuses.includes(option.value))}
                                placeholder="Filter by Job Status"
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                        <div><ShipmentCountCard /></div>
                        <div><ShipmentStatusCard /></div>
                        <div><FreightUnderManagementCard /></div>
                        <div><ShipmentTimingCard /></div>
                        <div><InventoryStatusCard /></div>
                        <div><ShipmentDefaultUqPieChart /></div>
                        <div><ShipmentArrivalCalendar /></div>
                        <div><StatusModulationCard /></div>
                        <div><TrafficReferenceTimeSeriesCard /></div>
                        <div><StatusPedimentoCard /></div>
                        <div><ShipmentTransBarChart /></div>
                        <div><ShipmentModeBarChart /></div>
                        <div><InventoryStatusPercentageCard /></div>
                        <div><ShipmentsPerWeekChart /></div>
                        <div><ShipmentTimeSeriesChart /></div>
                        <div><ShipmentsByCarrierPieChart /></div>
                        <div><ShipmentsByConsignorPieChart /></div>

                        {/* ... other cards */}
                    </div>
                </header>
            </div>
        </div>
    );
}

export default FFDashboard;
